module.exports = __webpack_public_path__ + "static/media/icon_hacker.9cf92076.png";